import { useMemo } from 'react';

import { PEBBLE_TOPICS, PebbleTopic } from 'src/util/pebbles';

export const usePebbleTopics = () => {
  const topics = useMemo(
    () => PEBBLE_TOPICS.filter(topic => topic.value !== PebbleTopic.BridgePrescriptionRequest),
    [],
  );
  return topics;
};
